import { useI18n } from '../i18n';
import { Button } from '../components/Button';
import { PhoneMockup } from '../components/PhoneMockup';
import { useWaitlist } from '../components/WaitlistProvider';
import styles from './Hero.module.css';

export function Hero() {
  const { t } = useI18n();
  const { open } = useWaitlist();
  const m = t.mockup;

  return (
    <section className={styles.hero}>
      <div className={styles.copy}>
        {/*
          Two lines, and the break is deliberate: the second line is the joke,
          and it only lands if it arrives on its own. Not a <br> inside one
          string, so the two halves stay separately translatable.
        */}
        <h1 className={styles.headline}>
          {t.hero.headlineA}
          <br />
          {t.hero.headlineB}
        </h1>

        <p className={styles.body}>{t.hero.body}</p>

        <div className={styles.ctas}>
          {/*
            Both store buttons open the waitlist rather than linking out,
            because the app is not published yet. When it is, these become
            real store links — see docs/working-on-it.html.
          */}
          <Button variant="primary" size="lg" onClick={() => open('hero-ios')}>
            {t.store.ios}
          </Button>
          <Button variant="outline" size="lg" onClick={() => open('hero-android')}>
            {t.store.android}
          </Button>
        </div>

        <p className={styles.trust}>
          <span className={styles.trustDot} aria-hidden="true" />
          {t.hero.reassurance}
        </p>
      </div>

      <PhoneMockup
        houseLabel={m.houseLabel}
        houseName={m.houseName}
        houseMeta={m.houseMeta}
        addLabel={m.add}
        shopLabel={m.shop}
        tabs={m.tabs}
        groups={[
          {
            label: m.produce,
            count: '3',
            rows: [
              { name: m.items.tomatoes, by: m.by.tomatoes, qty: '500g' },
              { name: m.items.lemons, by: m.by.lemons, photo: true },
              { name: m.items.coriander, by: m.by.coriander },
            ],
          },
          {
            label: m.dairy,
            count: '3',
            rows: [
              { name: m.items.oatMilk, by: m.by.oatMilk, photo: true },
              { name: m.items.butter, by: m.by.butter, qty: '250g' },
              { name: m.items.eggs, by: m.by.eggs, qty: '12' },
            ],
          },
        ]}
      />
    </section>
  );
}
